import React from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import D3Message from '@components/chat/chatDetail/messageList/adminMessage/D3Message';
import DDayMessage from '@components/chat/chatDetail/messageList/adminMessage/DDayMessage';
import AdminTextMessage from '@components/chat/chatDetail/messageList/adminMessage/AdminTextMessage';
import RegisteredMessage from '@components/chat/chatDetail/messageList/adminMessage/RegisteredMessage';
import DeadlineMessage from '@components/chat/chatDetail/messageList/adminMessage/DeadlineMessage';
import styles from '@components/chat/chatDetail/messageList/index.module.scss';
import useChatReactionMenu from '@components/chat/hooks/useChatReactionMenu';
import Time from '@components/chat/chatDetail/messageList/time';
import { AdminMessage as AdminMessageEnum, AdminMessageType } from '@domain/constant/AdminMessageType';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface AdminMessageProps {
  message: Message;
  name?: string | undefined;
  isReplying?: boolean;
  handleReply: (message: Message) => void;
}

const AdminMessage = (props: AdminMessageProps) => {
  const { message, name, isReplying, handleReply } = props;
  const { isReaction, handleMouseEnter, handleMouseLeave, getReactionMenuEl, getReactionListEl } = useChatReactionMenu({
    message,
    isReplying,
    handleReply,
  });

  const type = props.message.data?.type as AdminMessageType;

  const getContentsEl = () => {
    switch (type) {
      case AdminMessageEnum.REMIND_JOB_POSTING_DEADLINE_D_DAY:
        return <DDayMessage {...props} />;
      case AdminMessageEnum.REMIND_JOB_POSTING_DEADLINE_D_3:
        return <D3Message {...props} />;
      case AdminMessageEnum.REMIND_JOB_POSTING_DEADLINE:
        return <DeadlineMessage {...props} />;
      case AdminMessageEnum.REMIND_JOB_POSTING_REGISTERED:
        return <RegisteredMessage {...props} />;
      default:
        return <AdminTextMessage {...props} />;
    }
  };

  return (
    <li className={cx('messageArea', 'admin', { emoji: isReaction })}>
      {name && <span className={cx('name')}>📢JOBDA</span>}
      <div className={cx('textArea')}>
        <div
          className={cx('messageArea')}
          onMouseMove={handleMouseEnter}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {getContentsEl()}
          {getReactionListEl()}
          {getReactionMenuEl()}
        </div>
        <Time message={message} />
      </div>
    </li>
  );
};

export default AdminMessage;
